import { OfferFragment } from '@occc/graphql';

export const isEarningMechanismEarningMechanismPointSpend = (
  offer: OfferFragment,
): offer is Omit<OfferFragment, 'earningMechanism'> & {
  earningMechanism: Omit<
    Extract<OfferFragment['earningMechanism'], { __typename: 'EarningMechanismPointSpend' }>,
    'offerIsReturnable'
  > & {
    offerIsReturnable: NonNullable<
      Extract<
        OfferFragment['earningMechanism'],
        { __typename: 'EarningMechanismPointSpend' }
      >['offerIsReturnable']
    >;
  };
} => {
  return (
    offer.earningMechanism?.__typename === 'EarningMechanismPointSpend' &&
    offer.earningMechanism.offerIsReturnable !== null &&
    offer.earningMechanism.offerIsReturnable !== undefined
  );
};
